// extracted by mini-css-extract-plugin
export var aircallIframe = "_ls-3";
export var fabContainer = "_ls-5";
export var fabRinging = "_ls-6";
export var loadingOverlay = "_ls-4";
export var pulse = "_ls-7";
export var widgetContent = "_ls-2";
export var widgetPanel = "_ls-0";
export var widgetPanelExpanded = "_ls-1";